'use strict';

var DemandPostingTypeController = function DemandPostingTypeController($rootScope, $scope) {
  $scope.DUMMY = '';
};
DemandPostingTypeController.$inject = ['$rootScope', '$scope'];
module.exports = DemandPostingTypeController;